import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Tooltip, Button, Select, Input, Table } from "antd";
import { req_page_tut_school_roll } from "../../api";
import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";

class SchoolRollSearch extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    loading: false,
    deviceWidth: 0,
    userLevel: "NORMAL",
    item: {},
    // 分頁參數
    items: [],
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "None",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",
    isShowModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }
  // 遠端數據處理 //////////////////////////////////////////////
  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode, role } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    this.setState({ loading: true });
    const result = await req_page_tut_school_roll(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    this.setState({ loading: false });
    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };
  // 數據配置設定 //////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "姓名",
        dataIndex: "TwName",
        width: 60,
        fixed: "left",
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "身份證字號",
        dataIndex: "TwId",
        width: 100,
        fixed: "left",
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "學籍狀態",
        dataIndex: "SchoolRoll",
        width: 80,
        fixed: "left",
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "是否畢業",
        dataIndex: "StatusGraduate",
        width: 30,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "是否應屆",
        dataIndex: "NewGraduate",
        width: 30,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "畢業年月",
        dataIndex: "YMGraduate",
        width: 70,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "學號",
        dataIndex: "StudentId",
        width: 100,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "電話",
        dataIndex: "Phone",
        width: 90,
        responsive: ["md"],
        render: (field) => {
          return (
            <div>
              <span> {field}</span>
            </div>
          );
        },
      },
      {
        title: "戶籍地址",
        dataIndex: "ResidenceAddress",
        width: 150,
        responsive: ["md"],
        render: (field) => {
          return (
            <div>
              <span> {field}</span>
            </div>
          );
        },
      },
      {
        title: "通訊地址",
        dataIndex: "MailingAddress",
        width: 150,
        responsive: ["md"],
        render: (field) => {
          return (
            <div>
              <span> {field}</span>
            </div>
          );
        },
      },
      {
        title: "部別",
        dataIndex: "PartOf",
        width: 50,
        responsive: ["md"],
        render: (field) => {
          return (
            <div>
              <span> {field}</span>
            </div>
          );
        },
      },
      {
        title: "學制",
        dataIndex: "AcademicSystem",
        width: 50,
        responsive: ["md"],
        render: (field) => {
          return (
            <div>
              <span> {field}</span>
            </div>
          );
        },
      },
      {
        title: "科系",
        dataIndex: "DepartmentName",
        width: 100,
        responsive: ["md"],
        render: (field) => {
          return (
            <div>
              <span> {field}</span>
            </div>
          );
        },
      },
    ];
  };
  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  render() {
    const { loading, items, pagination, searchField, searchValue } = this.state;
    const title = (
      <>
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="None">搜索條件</Select.Option>
          <Select.Option value="TwName">姓名</Select.Option>
          <Select.Option value="TwId">身分證字號</Select.Option>
          <Select.Option value="StudentId">學號</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 150, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i> 查詢
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480, x: 500 }}
          loading={loading}
          rowKey="Id"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(SchoolRollSearch);
